<template>
  <div class="home">
    <br><br><br><br>
      <b-container fluid style="padding-top: 100px;">
        <b-row>
          <b-col lg="12" sm="12"><Header/></b-col>
        </b-row>
        <b-row style="color:#424242;height:2vh; margin-top:-9vh;margin-bottom:4vh" >

          <b-col cols="1" >
          <span id="fixedButton" >
              <ul>
                <li v-for="item in menuItems" :key="item.id" class="menu-nav-item"
                  :class="{ 'menu-nav-item-active': allOpenOnLoad || activeMenuItem === item.id }" tabindex="0"
                  @mouseover="openNav(item.id)" @focus="openNav(item.id)">
                  <b-icon :icon="item.icon" variant="light"></b-icon>
                </li>
              </ul>
          </span>

          <div v-for="item in menuItems" :key="item.id + '-panel'" :id="item.id + 'Sidenav'" class="sidenav"
            :class="{ open: allOpenOnLoad || activeMenuItem === item.id }" :style="{ top: item.top }"
            @mouseleave="closeNavAll()">
            <a :id="item.id" :target="item.target" :href="item.href" :aria-label="item.label">
              <b-icon :icon="item.icon"></b-icon>
              {{ item.label }}
            </a>
          </div>

          </b-col>


          <b-col cols="11">
             <marquee loop="2" style="display:block;">

                 <span v-for="item in getMarquee" :key="item.title">
                   <span class="m-text"  v-html="item.title"></span>
                   <span>
                      |
                    </span>
                 </span>
            </marquee>
          </b-col>

         </b-row>
         <b-row class="mt-2">
        <b-col cols="12">
          <div class="app-update-ribbon">
            <b-icon icon="info-circle-fill" class="mr-2"></b-icon>
            <span>
              <strong>myBijulee</strong> মোবাইল এপ্লিকেশনৰ এণ্ড্ৰইড সংস্কৰণ ব্যৱহাৰ কৰাৰ সময়ত কোনো অসুবিধাৰ সন্মুখীন হোৱা ব্যৱহাৰকাৰীসকলক 
              <strong>গুগল প্লে ষ্টোৰত উপলব্ধ শেহতীয়া সংস্কৰণলৈ</strong> এপ্লিকেশ্যনটো আপডেট কৰিবলৈ এইদ্বাৰা অৱগত কৰা হৈছে।
            </span>
          </div>
        </b-col>
      </b-row>
         <b-row>
          <b-col cols="12">
            <!-- Sticker-style Customer Support Banner -->
            <router-link
              to="/ContactCustomerCare"
              custom
              target="_blank"
              class="customer-support-banner"
            >
              <div>
                For any electricity-related issues, contact our <strong>24x7 Customer Support</strong> at
                <strong>1912 (Calls made from within Assam) / 022-35296117 or 022-69132900 (Calls made from outside Assam)</strong> or email at
                <strong>support@apdcl.org</strong>
              </div>
              <div style="margin-top: 8px;">
                (বিদ্যুৎ সম্পৰ্কীয় যিকোনো সমস্যাৰ বাবে আমাৰ <strong>২৪x৭ গ্ৰাহক সহায়ক নম্বৰ </strong>
                <strong>১৯১২ (অসমৰ পৰা অহা ফোন কলৰ বাবে) / ০২২-৩৫২৯৬১১৭ বা ০২২-৬৯১৩২৯০০ (অসমৰ বাহিৰৰ পৰা অহা ফোন কলৰ বাবে)</strong> বা
                <strong>support@apdcl.org</strong> ই-মেইলত যোগাযোগ কৰক)
              </div>
            </router-link>
          </b-col>
         </b-row>
        <b-row>
          <b-col cols="12" lg="9" class="banner-pc"><Banner/></b-col>
          <b-col cols="12" lg="3" class="payment-pc"><Payment/></b-col>
        </b-row>


      <b-row style="margin-left:-30px; margin-right:-30px;padding-top:5vh">
          <b-col lg="12" sm="12">  <BottomFixedNav/></b-col>
      </b-row>

      <br>
      <b-row style="padding-top:10px">
          <b-col cols="12">  <HomepageCardComponents/> </b-col>
      </b-row>
      <br>

      <b-row style="padding-top:10px">
          <b-col cols="12">  <Footer/> </b-col>
      </b-row>
      </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import Banner from '@/components/HomeBanner.vue'
import Payment from '@/components/AS_HomePayment.vue'
import BottomFixedNav from '@/components/AS_HomeBottomFixedNav.vue'
import HomepageCardComponents from '@/components/AS_HomeCardComponents.vue'
import Header from '@/components/AS_Header.vue'
import Footer from '@/components/AS_Footer.vue'
//import MarqueeText from 'vue-marquee-text-component'
//console.log(Banner);
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Home',
  components: {
    'Banner' : Banner,
    'Payment' : Payment,
    'BottomFixedNav' : BottomFixedNav,
    'HomepageCardComponents' : HomepageCardComponents,
    'Header' : Header,
    'Footer' : Footer
    //MarqueeText

  },

  data() {
      return {
       activeMenuItem: null,
       allOpenOnLoad: true,
       autoCloseTimer: null,
       menuItems: [
         { id: 'menuItem0', top: '32vh', icon: 'phone', label: 'এপিডিচিএল ইজি পে', href: 'https://www.apdclrms.com/easypay/login', target: '_blank' },
         { id: 'menuItem1', top: '40vh', icon: 'lightning', label: 'স্বেচ্ছামূলক লোড ঘোষণা আঁচনি', href: 'AS_VldScheme', target: null },
         { id: 'menuItem2', top: '48vh', icon: 'card-list', label: "হ'ল্ডিং নম্বৰ আপডেট কৰক", href: 'AS_HoldingNoUpdate', target: null },
         { id: 'menuItem3', top: '56vh', icon: 'layers', label: 'Section 194Q ৰ সম্মতি', href: 'AS_TanUpdate', target: null },
         { id: 'menuItem4', top: '64vh', icon: 'pencil', label: 'অভিযোগ পঞ্জীয়ন কৰক', href: 'http://www.bijuleebandhu.com/', target: '_blank' },
       ],
       getMarqueeFields: [
           { key: 'title', label: '' }

         ]
      }

  },
  computed:
  {
    ...mapGetters([
      'getMarquee'
    ])
  },
  methods: {
    ...mapActions([
      'retrieveMarquee'

    ]),

    openNav(id) {
      this.allOpenOnLoad = false;
      this.activeMenuItem = id;
    },

    closeNavAll() {
      this.allOpenOnLoad = false;
      this.activeMenuItem = null;
    }
  },
  beforeMount() {
      if(this.getMarquee.length == 0){
        this.retrieveMarquee();

      }
  },
  mounted() {
    this.autoCloseTimer = setTimeout(() => {
      this.allOpenOnLoad = false;
    }, 30000);
  },
  beforeDestroy() {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
    }
  }
}

</script>


<style>
.app-update-ribbon {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  background: linear-gradient(90deg, #fff3e0, #ffcc80);
  color: #e65100;

  padding: 12px 16px;
  border-left: 6px solid #fb8c00;
  border-radius: 6px;

  font-size: 0.85rem;
  font-weight: 600;

  text-align: center;
  margin-bottom: 10px;
  margin-left: 20px;

  /* Pulse animation */
  animation: pulse-orange 1s infinite;
}

@keyframes pulse-orange {
  0% {
    box-shadow: 0 0 0 0 rgba(251, 140, 0, 0.45); /* orange */
  }
  70% {
    box-shadow: 0 0 0 10px rgba(245, 124, 0, 0.4); /* deep orange */
  }
  100% {
    box-shadow: 0 0 0 0 rgba(251, 140, 0, 0);
  }
}

.app-update-ribbon svg {
  margin-right: 2px;
  font-size: 0.95rem;
}
.customer-support-banner {
  display: block;
  background-color: #fff8e1; /* sticky-note look */
  /* border-left: 6px solid #ff9800; */
  border-left: 6px solid #0277bd;
  border-right: 6px solid #0277bd;
  border-top: 6px solid #0277bd;
  border-bottom: 6px solid #0277bd;
  /* padding: 16px 20px; */
  border-radius: 10px;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.15);
  color: #333;
  text-decoration: none;
  font-weight: 500;
  line-height: 1.6;
  /* max-width: 1000px; */
  /* margin: 10px auto; */
  margin-bottom: 5px;
  transition: all 0.2s ease-in-out;
}

.customer-support-banner:hover {
  background-color: #ffecb3;
  box-shadow: 4px 6px 14px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
  cursor: pointer;
}

.customer-support-banner .support-line {
  display: block;
  font-size: 1rem;
  margin-bottom: 4px;
}
#fixedButton {
  height: 40vh;
  top: 32vh;
  left: 0;
  position: fixed;
  z-index: 100;
  font-size: 1.6vw;
  cursor: pointer;
  border: 1px solid #bf360c;
  background-color: #e44c15d6;
  border-radius: 0 10px 10px 0;
  transition: 0.5s;
  padding: 10px;
}

#fixedButton ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.menu-nav-item {
  height: 8vh;
  border-bottom: 1px solid #ffffff;
  outline: none;
  transition: background-color 0.2s ease;
}

.menu-nav-item:nth-child(1),
.menu-nav-item:nth-child(2) {
  height: 7vh;
}

.menu-nav-item:last-child {
  border-bottom: none;
}

.menu-nav-item-active {
  background-color: rgba(255, 255, 255, 0.18);
}

.sidenav {
  height: 8vh;
  width: 0;
  position: fixed;
  z-index: 101;
  left: 0;
  border: 1px solid #e64a19;
  background-color: #e44c15e8;
  overflow-x: hidden;
  overflow-y: hidden;
  transition: width 0.5s ease;
  cursor: default;
  border-radius: 0 10px 10px 0;
}

.sidenav.open {
  width: 23vw;
}

.sidenav a {
  padding: 10px 8px 0 8px;
  text-decoration: none !important;
  text-align: left;
  color: #ffffff !important;
  display: block;
  white-space: nowrap;
  font-size: 1rem;
  font-weight: 500;
}

.sidenav a:hover {
  color: #212121 !important;
}

@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }

  .sidenav a {
    font-size: 18px;
  }
}

.home {
  margin-top: 0px;
  height:100vh;
  background-image: url('../assets/bg4.jpg');

 background-repeat: no-repeat;
 background-attachment: fixed;
 background-size: 100% 100%;
 box-shadow:inset 0 0 0 2000px  #ffffffbf;;

}
.banner-mb{
  display:none;
}
.payment-mb{
  display:none;
}


.m-text{
  padding:10px 10px 0px 10px;
}
@font-face {
  font-family: Assamese_Font;
  src: url("../assets/Assamese_font/KirtanUni.ttf");
}
div{
    font-family: arial,Assamese_Font;
}


</style>